












import { Component, Vue } from 'vue-property-decorator'
import Qiyu from '@/lib/qiyu'
import globalConfig from '@/lib/http/global-config'
import axios from 'axios'

@Component
export default class Hotline extends Vue {
  private pz: any = {}
  private $axios: any
  private $tsignData: any
  private qiyu: any
  private $isClient: any

  public mounted() {
    this.getPz()
    this.qiyuConfig()
  }

  public openWi() {
    this.qiyuTrack()
    this.qiyu.open()
  }

  public async getPz() {
    const r1 = (await this.$axios.get(`/api/config/show/10001`).catch(() => {})) || {}
    // var r8 = await this.$axios.$get(`/api/config/show/10008`)
    this.pz = {
      r1: r1.data,
      // r8:r8.data,
    }
  }

  // ---------------------配置七鱼客服----------------------'
  public qiyuConfig() {
    const { eBaseUrl }: any = globalConfig || {}
    this.qiyu = new Qiyu({
      axios, // 新生成一个实例传给七鱼进行配置
      server: eBaseUrl,
    })
    !this.$isClient &&
      this.qiyu.onready(() => {
        const ysfDom: any = document.getElementById('YSF-BTN-HOLDER')
        const that = this
        ysfDom.addEventListener('click', function() {
          console.log('qiyu is clicked!')
          that.qiyuTrack()
        })
      })
  }

  // 后续用注解优化
  public qiyuTrack() {
    console.log('click_customer_service is tracked')
    this.$tsignData.track('click_customer_service')
  }

  public phoneCallTrack() {
    console.log('click_phone_call is tracked!')
    this.$tsignData.track('click_phone_call')
  }
}
